import { Drawer } from "antd";
import close from "./../../../assets/images/close.svg";
import SearchBar from "./SearchBySpeciality";
import SpecialityList from "./SpecialityList";
import { useState } from "react";

const SpecializationSheet = ({
  show,
  closePopup,
  specialities,
  handleSpeciality,
}: any) => {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredSpecialities = searchTerm
    ? specialities?.filter((s: any) =>
      s?.displayName?.toLowerCase().includes(searchTerm?.toLowerCase())
    )
    : specialities;

  return (
    <Drawer
      placement="bottom"
      onClose={() => {
        setSearchTerm("");
        closePopup();
      }}
      closeIcon={false}
      open={show}
      height="90vh"
      className="rounded-t-2xl overflow-hidden max-h-[90vh]"
      style={{ maxWidth: "1280px", margin: "auto" }}
    >
      <div className="flex flex-col">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">Select Speciality</div>
          <img src={close} alt="close" onClick={closePopup} />
        </div>
      </div>
      <section className="flex flex-col text-base bg-white rounded-3xl w-full">
        <SearchBar value={searchTerm} onChange={setSearchTerm} />
        <SpecialityList
          onSpecialitySelect={(value) => {
            setSearchTerm("");
            handleSpeciality(value);
          }}
          specialities={filteredSpecialities}
        />
      </section>
    </Drawer>
  );
};

export default SpecializationSheet;
